import React from 'react';
import {Toolbar} from 'react-admin';
import DripCampaignSaveButton from './DripCampaignSaveButton';

const DripCampaignToolbar = ({save, saving, ...props}) => {
    return (
        <Toolbar {...props}>
            <DripCampaignSaveButton
                save={save}
                saving={saving}
            />
        </Toolbar>
    );
};

export default DripCampaignToolbar;